module.exports = __webpack_public_path__ + "0e8bb5d6691f303359bf9a861d417e65.png";